<div class="paste-textarea-card" [class.state-warning]="state === 'warning'" [class.state-error]="state === 'error'">
  <!-- Header -->
  <div class="card-header">
    <div class="header-icon">
      <mat-icon>auto_awesome</mat-icon>
    </div>
    <div class="header-text">
      <h2>{{ title }}</h2>
      <p>{{ t.HEADER_SUBTITLE || 'Paste your content and let AI help you' }}</p>
    </div>
  </div>

  <!-- Textarea Section -->
  <div class="textarea-section">
    <label class="textarea-label">
      <mat-icon>edit_note</mat-icon>
      {{ t.TEXTAREA_LABEL || 'Your content' }}
    </label>

    <div class="textarea-container" [class.state-warning]="state === 'warning'" [class.state-error]="state === 'error'">
      <textarea
        [rows]="rows"
        pTextarea
        [(ngModel)]="textValue"
        [class.state-warning]="state === 'warning'"
        [class.state-error]="state === 'error'"
        [placeholder]="placeholder"
        class="paste-textarea"
        (ngModelChange)="onTextChange($event)"
      ></textarea>

      <!-- Status Icon -->
      <div class="status-icon" *ngIf="state !== 'normal'">
        <div class="icon-circle" [class.warning]="state === 'warning'" [class.error]="state === 'error'">
          <mat-icon *ngIf="state === 'warning'">warning</mat-icon>
          <mat-icon *ngIf="state === 'error'">error</mat-icon>
        </div>
      </div>
    </div>

    <!-- Footer: Validation message + Character counter -->
    <div class="textarea-footer">
      <div class="validation-message">
        <span class="error-text" *ngIf="state === 'error' && isOverLimit">
          <mat-icon>error</mat-icon>
          {{ interpolate(t.ERROR_TOO_LONG || '{excess} characters over the limit', { excess: excessCharacters }) }}
        </span>
        <span class="warning-text" *ngIf="state === 'warning'">
          <mat-icon>warning</mat-icon>
          {{ interpolate(t.WARNING_NEAR_LIMIT || '{remaining} characters remaining', { remaining: remainingCharacters }) }}
        </span>
        <span class="error-text" *ngIf="errorMessage">
          <mat-icon>error</mat-icon>
          {{ errorMessage }}
        </span>
      </div>
      <div class="char-counter" [class.warning]="state === 'warning'" [class.error]="state === 'error'" *ngIf="showCharacterCount">
        {{ characterCount }} / {{ maxChars }}
      </div>
    </div>

    <!-- Optional host-provided hint below the textarea (e.g. the job
         description step's link-vs-text detection pill). -->
    <ng-content select="[pasteHint]"></ng-content>
  </div>

  <!-- Action Bar -->
  <div class="action-bar">
    <button
      pButton
      type="button"
      (click)="handleCancel()"
      [disabled]="loading"
      class="back-btn"
    >
      <i class="pi pi-arrow-left"></i>
      <span>{{ cancelText }}</span>
    </button>

    <div class="submit-section">
      <button
        pButton
        type="button"
        [disabled]="!canSubmit"
        class="submit-btn"
        (click)="handleSubmit()"
      >
        <i class="pi pi-sparkles" *ngIf="!loading"></i>
        <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
        <span>{{ loading ? t.SUBMITTING : submitText }}</span>
      </button>
    </div>
  </div>

  <!-- Floating Dock (right side, like other components) -->
  <p-dock
    *ngIf="isInsideWizard && dockItems.length > 0"
    [model]="dockItems"
    position="right"
    [ngClass]="{ 'dock-fixed': true, 'dock-open': isMobileView && isMobileDockOpen }"
  >
    <ng-template pTemplate="item" let-item>
      <i [class]="item.icon + ' dock-icon'"></i>
    </ng-template>
  </p-dock>

  <!-- Mobile Dock Overlay and Trigger -->
  @if (isInsideWizard && isMobileView) {
    @if (!isMobileDockOpen) {
      <app-right-dock-expand-trigger
        [visible]="true"
        (onClick)="toggleMobileDock()"
      ></app-right-dock-expand-trigger>
    }
  }
</div>
